import React from "react";
import clsx from "clsx";
import styles from "./ComponentCard.module.css";

interface StockStatusDisplayProps {
	stockStatus: { iconClass?: string; description?: string };
}

const StockStatusDisplay: React.FC<StockStatusDisplayProps> = ({ stockStatus }) => (
	<div className={styles.stockStatus}>
		<div
			className={clsx(styles.stockIndicator, stockStatus.iconClass)}
			aria-hidden="true"
		/>
		<span className={styles.stockText}>{stockStatus.description}</span>
	</div>
);

export default StockStatusDisplay;